import {isFulfilled} from '@reduxjs/toolkit';

import {accountSettingsSelector} from 'app/settings/api';
import {setReloadRequired} from 'app/settings/slice';
import {withSentryScope} from 'app/utils/sentry';

import type {AppDispatchType} from '../AppStore';
import type {AnyAction, Middleware} from '@reduxjs/toolkit';

// flag used to show the message once
let sentToSentry = false;

// this middleware identify global errors (that are not related with the API being accessed)
// and heandle them
export const AppVersionCheckerMiddleware: Middleware =
  (store) => (next: AppDispatchType) => (action: AnyAction) => {
    // it's a request being fulfilled action
    if (isFulfilled(action)) {
      // fetch redux stored app-version
      const appHTMLVersion = accountSettingsSelector(store.getState()).data
        ?.APP_HTML_VERSION;

      // probably it's the first request, redux have no app-version yet, so bail out
      if (appHTMLVersion == null) {
        return next(action);
      }

      // try to get app-version from the response
      const backendHTMLVersion = (
        action.meta as any
      ).baseQueryMeta?.response?.headers.get('X-HTML-Version');

      // response have no app-version? bail out
      if (backendHTMLVersion == null) {
        return next(action);
      }

      // we do have app-versions on both response and redux and they are different, the app
      // version was changed
      if (appHTMLVersion !== backendHTMLVersion) {
        store.dispatch(setReloadRequired(true));

        // we do multiple requests per page, so let's use a flag to
        // send the reload-requiredmessage to Sentry once
        if (!sentToSentry) {
          sentToSentry = true;

          withSentryScope((scope) => {
            scope.setLevel('info');

            // use the same keys as the old mechanism
            scope.setExtra('frontVersion', appHTMLVersion);
            scope.setExtra('backVersion', backendHTMLVersion);
            scope.setExtra(
              'triggerURL',
              (action.meta as any)?.baseQueryMeta?.request.url
            );
          });
        }
      }
    }

    return next(action);
  };
